import { render, staticRenderFns } from "./LogoModal.vue?vue&type=template&id=111a4b68&"
import script from "./LogoModal.vue?vue&type=script&lang=js&"
export * from "./LogoModal.vue?vue&type=script&lang=js&"
import style0 from "./LogoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports